import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../../app/_services/authentication/authentication.service';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

const _canActivate = (
  auth: AuthenticationService,
  router: Router,
): boolean | Observable<boolean> => {
  if (auth.isLoggedIn()) return true;
  if (!auth.hasStoredSession()) {
    router.navigate(['']);
    return false;
  }
  return auth.refreshToken().pipe(
    switchMap(() => (auth.session.getUser() ? of(null) : auth.loadContext())),
    map(() => auth.isLoggedIn()),
    catchError((error) => {
      // A network/server failure cancels navigation without discarding the
      // session. The next navigation or reconnection can attempt renewal.
      if (error.status === 401) router.navigate(['']);
      return of(false);
    }),
  );
};

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    public auth: AuthenticationService,
    public router: Router,
  ) {}
  canActivate(
    _route?: ActivatedRouteSnapshot,
    state?: RouterStateSnapshot,
  ): boolean | Observable<boolean> {
    return _canActivate(this.auth, this.router);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuthGuardChild {
  constructor(
    public auth: AuthenticationService,
    public router: Router,
  ) {}
  canActivateChild(
    _route?: ActivatedRouteSnapshot,
    state?: RouterStateSnapshot,
  ): boolean | Observable<boolean> {
    return _canActivate(this.auth, this.router);
  }
}
